// extracted by mini-css-extract-plugin
module.exports = {"iconPosition":"IconBlock_iconPosition__jHfLL","iconPadding":"IconBlock_iconPadding__gwhA5"};